<template>
  <div>
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">市场管理</Breadcrumb-item>
        <Breadcrumb-item>分享有礼海报管理</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div>
      <Form :label-width="100" :show-message="false" label-position="left">
        <Row :gutter="32">
          <Col :xs="11" :sm="6" :md="5">
            <Form-item :label-width="60" label="归属活动">
              <Col>
                <activity-select v-model="queryParams.activityId" :label="name"></activity-select>
              </Col>
            </Form-item>
          </Col>
          <Col :xs="11" :sm="6" :md="5">
            <Form-item :label-width="60" label="海报分类">
              <Col>
                <Select v-model="queryParams.sharePosterType" clearable>
                  <Option v-for="item in $constant.sharePosterType" :value="item.code" :key="item.code">
                    {{ item.text }}
                  </Option>
                </Select>
              </Col>
            </Form-item>
          </Col>
          <Col :xs="11" :sm="6" :md="5">
            <Form-item :label-width="40" label="状态">
              <Select v-model="queryParams.status" clearable>
                <Option value="1" key="1">启用</Option>
                <Option value="0" key="2">禁用</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xs="11" :sm="6" :md="5">
            <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search" @click="search">
              搜索
            </Button>
          </Col>
        </Row>
        <Row type="flex" justify="end">
          <Button type="primary" :loading="searchLoading" :disable="searchLoading" @click="toShowAddposterModel">
            添加海报
          </Button>
        </Row>
      </Form>
    </div>
    <List style="margin-top: 10px" :tableColumns="tableColumns" listUrl="/share/poster/page"
          :params="queryParams" :onLoading="onLoading" :reload="reload"></List>

    <CreateShareModal v-model="showAddPosterModel" @on-close="closeModal" :uid="uid"
                      :successCallback="search"></CreateShareModal>

    <Modal title="编辑海报" v-model="showUpdatePosterModel">
      <Form class="form" :rules="shareRules" ref="updatePosterForm" :model="updatePosterParams">
        <Row>
          <FormItem :label-width="90" label="海报名称：" prop='name'>
            <Input v-model="updatePosterParams.name" placeholder="请输入活动名称用于列表展示"></Input>
          </FormItem>
          <FormItem :label-width="90" label="海报分类：" prop='sharePosterType'>
            <Select v-model="updatePosterParams.sharePosterType">
              <Option v-for="item in $constant.sharePosterType" :value="item.code" :key="item.code">{{ item.text }}
              </Option>
            </Select>
          </FormItem>
          <FormItem :label-width="90" label="活动归属：" prop='activityId'>
            <activity-select v-model="updatePosterParams.activityId" :label="name"></activity-select>
          </FormItem>
          <FormItem :label-width="90" label="配套海报：" prop='url'>
            <image-upload-New :defaultFileList="updateDefalutPic" v-model="updatePosterParams.url"/>
          </FormItem>
          <FormItem :label-width="90" label="海报排序：" prop='sort'>
            <InputNumber v-model="updatePosterParams.sort" :min="0" :max="100000"></InputNumber>
          </FormItem>
          <FormItem :label-width="90" label="海报状态：" prop='status'>
            <Select v-model="updatePosterParams.status">
              <Option value="no" key="1">禁用</Option>
              <Option value="yes" key="2">启用</Option>
            </Select>
          </FormItem>
        </Row>
      </Form>
      <div slot="footer">
        <Button type="text" size="large" @click="showUpdatePosterModel = false">取消</Button>
        <Button type="primary" size="large" :loading="loadingAddPoster" @click="update">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import ActivitySelect from '../common/ActivitySelect.vue'
import CreateShareModal from '@/components/market/modal/CreateShareModal'

export default {
  components: {ActivitySelect, CreateShareModal},
  data() {
    let $constant = this.$constant
    return {
      updateDefalutPic: [],
      showAddPosterModel: false,
      showUpdatePosterModel: false,
      searchLoading: false,
      loadingAddPoster: false,
      selectionUser: [],
      reload: 0,
      updatePosterParams: {
        id: '',
        name: '',
        sharePosterType: '',
        activityId: '',
        activityName: '',
        status: '',
        url: '',
        sort: null,
        createTime: '',
        updateTime: ''
      },
      queryParams: {
        name: '',
        sharePosterType: '',
        activityId: '',
        activityName: '',
        status: '',
        url: '',
        sort: null,
        createTime: '',
        updateTime: ''
      },
      shareRules: {
        name: [
          {type: 'string', required: true, message: '请输入海报名称', trigger: 'blur'},
          {pattern: /^[\u4E00-\u9FA5A-Za-z0-9]{2,20}$/, message: '只能输入中文、英文和数字', trigger: 'blur'}
        ],
        sharePosterType: [
          {required: true, message: '选择海报分类', trigger: 'blur'}
        ],
        activityId: [
          {type: 'integer', required: true, message: '请选择活动归属', trigger: 'blur'}
        ],
        url: [
          {type: 'string', required: true, message: '请上传图片', trigger: 'blur'}
        ],
        sort: [
          {type: 'number', required: true, message: '请输入图片排序', trigger: 'blur'}
        ],
        status: [
          {type: 'integer', required: true, message: '请选择渠道状态', trigger: 'blur'}
        ]
      },
      tableColumns: [
        // {
        //     type: 'selection',
        //     width: 60,
        //     align: 'center'
        // },
        {
          title: '海报id',
          // width: 100,
          key: 'id',
          sortable: true
        },
        {
          title: '海报名称',
          // width: 120,
          key: 'name'
        },
        {
          title: '海报分类',
          // width: 100,
          align: 'center',
          key: 'sharePosterType',
          render: (h, params) => {
            let row = params.row
            return h('span', $constant.getEnum($constant.sharePosterType, row.sharePosterType).text)
          }
        },
        {
          title: '预览',
          height: 10,
          // width: 120,
          align: 'center',
          key: 'url',
          render: (h, params) => {
            let row = params.row
            return h('viewer', [
              h('img', {
                style: {
                  width: '100px',
                  cursor: 'pointer',
                },
                attrs: {
                  src: row.url
                }
              })
            ])
          }
        },
        {
          title: '归属活动',
          // width: 120,
          align: 'center',
          key: 'activityName'
        },
        {
          title: '海报排序',
          // width: 120,
          align: 'center',
          key: 'sort',
          sortable: true
        },
        {
          title: '状态',
          // width: 120,
          align: 'center',
          key: 'status',
          render: (h, params) => {
            let row = params.row
            return h('div', row.status == 1 ? '启用' : '禁用')
          }
        },
        {
          title: '创建时间',
          // width: 180,
          align: 'center',
          key: 'createTime',
          sortable: true
        },
        {
          title: '操作',
          // width: 130,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('div', [
              h('a', {on: {click: () => this.toShowUpdateModel(row)}}, '编辑'),
            ])
          }

        }
      ]
    }
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {
    toShowAddposterModel() {
      let self = this
      self.showAddPosterModel = true
    },
    toShowUpdateModel(row) {
      let self = this
      self.updatePosterParams.id = row.id
      self.updatePosterParams.name = row.name
      self.updatePosterParams.sharePosterType = row.sharePosterType
      self.updatePosterParams.activityId = row.activityId
      self.updatePosterParams.activityName = row.activityName
      self.updatePosterParams.status = row.status == 1 ? 'yes' : 'no'
      self.updatePosterParams.url = row.url
      this.updateDefalutPic = row.name ? [{name: row.name, url: row.url}] : []
      self.updatePosterParams.sort = row.sort ? row.sort : null
      self.updatePosterParams.createTime = row.createTime
      self.updatePosterParams.updateTime = row.updateTime
      self.showUpdatePosterModel = true
    },
    update() {
      let self = this
      self.updatePosterParams.status = self.updatePosterParams.status == 'yes' ? 1 : 0
      self.$refs.updatePosterForm.validate((valid) => {
        if (!valid) {
          self.$Message.warning('信息输入错误!')
          self.loadingAddPoster = false
          return
        }
        self.$http.post('/share/poster/update', self.updatePosterParams).then(res => {
          if (res) {
            console.log(res)
            self.$message.success('成功')
            self.search()
            self.showUpdatePosterModel = false
          }
        }).catch(err => {
          console.log(`err`, err)
          self.$message.error(err)
          self.showUpdatePosterModel = false
        })
      })

    },
    closeModal(val) {
      this.uid = null
      this.editUser = false
    },
    search() {
      this.selectionUser = []
      this.reload = new Date().getTime()
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// ShareManagement.vue?2d30bcc4